// Every request to the dietitian API carries the signed-in staff member's token, including
// pages that call fetch() directly instead of the apiRequest helpers. The API refuses
// anonymous calls except a few public paths (dietitian-server/utils/staffAuth.js).
import API_BASE_URL from '../config/api';
import { authClient } from './authClient';

// Some components still call the production URL directly.
const PRODUCTION_API_ORIGIN = 'https://newdietitianweb-615263253386.europe-west3.run.app';

function originOf(url) {
  try {
    return new URL(url).origin;
  } catch {
    return null;
  }
}

/**
 * Should this request get the token? Only our API, never /api/auth/* (signing in and
 * refreshing the session must not wait on a token), and never when one is already set.
 */
export function needsApiToken(url, headers, apiOrigins) {
  const origin = originOf(url);
  if (!origin || !apiOrigins.includes(origin)) return false;
  if (/\/api\/auth\//.test(new URL(url).pathname)) return false;
  const existing = headers instanceof Headers ? headers.get('Authorization') : headers?.Authorization || headers?.authorization;
  return !existing;
}

export function installApiAuthFetch(win = window) {
  if (!win?.fetch || win.fetch.__apiAuth) return;
  const apiOrigins = [originOf(API_BASE_URL), PRODUCTION_API_ORIGIN].filter(Boolean);
  const plainFetch = win.fetch.bind(win);

  const authedFetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url;
    const absolute = url ? new URL(url, win.location?.href).toString() : null;
    if (!absolute || !needsApiToken(absolute, init.headers, apiOrigins)) return plainFetch(input, init);
    const token = await authClient.getAccessToken().catch(() => null);
    if (!token) return plainFetch(input, init);
    const headers = new Headers(init.headers || (typeof input === 'object' ? input.headers : undefined));
    headers.set('Authorization', `Bearer ${token}`);
    return plainFetch(input, { ...init, headers });
  };
  authedFetch.__apiAuth = true;
  win.fetch = authedFetch;
}
